// Third-party Library
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import { MdFilterList } from 'react-icons/md';


// Internal Library
import atoms from "../../../../atoms";
import molecules from "../../../../molecules";
import { ProductFilterModuleProps } from "../../interface";
import constant from "../../../../../constants/constant";
import { CiFilter } from "react-icons/ci";
import { useMediaQuery } from "react-responsive";

const { Search, Button, Select, Input } = atoms
const { ContactLensContainer } = molecules

export const ProductFilterModule: React.FC<ProductFilterModuleProps> = ({
    inputRef,
    setCurrentPage,
    setSearch,
    isContactLensProduct,
    handleLensTypeChange,
    showFilter,
    setShowFilter,
    isRecognize,
    navigate,
    filterData,
    brandList,
    handleChange,
    productTypeList,

}) => {
    const isMediumScreen = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1024px)' });

    const myStyle = {
        height: "44px",
        margin: 0,
        background: showFilter && "#05B7E4",
        color: showFilter && "#fff"
    };

    return (
        <div>
            {/* upper part */}
            <div className="d-flex mb-2">
                <ContactLensContainer
                    value={isContactLensProduct}
                    onStatusChange={(value: boolean) => handleLensTypeChange(value)}
                />
            </div>
            {/* end */}
            {/* Lower Part */}
            <div className="d-lg-flex gap-1 justify-content-between">
                <div className="d-lg-flex gap-2 mb-2">
                    <div>
                        <Search
                            refs={inputRef}
                            searchCallBack={(e: string) => {
                                setCurrentPage(1);
                                setSearch(e);
                            }}
                            className="w-100"
                            searchIconPlace="search-icon-position"
                        />
                    </div>
                    <div className="d-none d-lg-block" style={{minWidth:isMediumScreen ? "" : "180px"}}>
                        <Select
                            options={brandList}
                            className={"w-100 product_multi_select"}
                            placeholder={"Select Brand"}
                            value={filterData?.brand_id}
                            isMulti={true}
                            onChange={(e: any) => {
                                setCurrentPage(1);
                                handleChange("brand_id", e);
                            }}
                        />
                    </div>
                    {!isContactLensProduct && (
                        <div className="d-none d-lg-block" style={{minWidth:isMediumScreen ? "" : "180px"}}>
                            <Select
                                options={productTypeList}
                                className={"w-100 product_multi_select"}
                                placeholder={"Select Type"}
                                value={filterData.product_type_id}
                                isMulti={true}
                                isDisabled={isContactLensProduct}
                                onChange={(e: any) => {
                                    setCurrentPage(1);
                                    handleChange("product_type_id", e);
                                }}
                            />
                        </div>
                    )}
                    {!isContactLensProduct && (
                        <div className="d-none d-lg-block" style={{maxWidth:"185px"}}>
                            <Input
                                type={"text"}
                                className="input-height"
                                value={filterData.modal_number}
                                placeholder={"Enter Model Number"}
                                disabled={isContactLensProduct}
                                onChange={(e: any) => {
                                    setCurrentPage(1);
                                    handleChange("modal_number", e.target.value);
                                }}
                            />
                        </div>
                    )}

                </div>
                <div>
                    <div className="d-flex justify-content-lg-center justify-content-end gap-3">
                        <Button
                            name={"Add Product"}
                            style={{ minWidth: "140px", height: "44px" }}
                            onClick={() =>
                                navigate(
                                    `/product/add?isRecognize=${isRecognize
                                        ? constant.BRAND_CATEGORY[0].value
                                        : constant.BRAND_CATEGORY[1].value
                                    }`
                                )
                            }
                        />
                        <div className="d-lg-none my-auto">
                            <Button className='d-flex align-items-center border button-transparent rounded' style={myStyle} onClick={() => setShowFilter(!showFilter)}>
                                <div className='fs-18 me-2 '>
                                    <CiFilter className='fw-600' />
                                </div>
                                <div className='fs-16 fw-400'>Filter</div>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};
